import React from "react";
import { Route, Routes } from "react-router-dom";

import NotFoundPage from "../404";
import ManageLoadPost from "./Manage";
import LoadPostDetailPage from "./Detail";
import SipperLoadPostList from "./SipperLoadPostList";

const LoadPost = () => {
  return (
    <Routes>
      <Route path="/create" element={<ManageLoadPost isForUpdate={false} />} />
      <Route
        path="/update/:loadPostId"
        element={<ManageLoadPost isForUpdate={true} />}
      />
      <Route path="/details/:loadPostId" element={<LoadPostDetailPage />} />
      <Route path="*" element={<NotFoundPage />} />
      <Route path="/shipper-loadpost" element={<SipperLoadPostList />} />
    </Routes>
  );
};

export default LoadPost;
